var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FastOrdersTableAdmin',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams},on:{"changeTab":_vm.changeTab,"resetFilter":_vm.resetFilter,"changeFilter":_vm.changeFilter,"showMore":_vm.showMore,"reload":_vm.reload,"deleteItem":_vm.deleteItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }